import { ProtectedRoute } from '../components/ProtectedRoute';
import StakeholderDashboard from './StakeholderDashboard';

export default function ProtectedStakeholderDashboard() {
  return (
    <ProtectedRoute>
      <StakeholderDashboard />
    </ProtectedRoute>
  );
}
